export const state = {
  loading: false,
  currentUser: null
}

export const getters = {
  isLoggedIn() {
    return state.currentUser != null
  }
}

export const actions = {}

export const mutations = {
  SET_AUTH_LOADING(state, loading) {
    state.loading = loading
  },
  SET_CURRENT_USER(state, me) {
    state.currentUser = me
  }
}
